
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","viewBox":"0 0 20 19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.305 4.783L16.108 5.98l-2.99-2.995 1.196-1.196a.66.66 0 01.912 0l2.079 2.082a.646.646 0 010 .912zM7.31 14.79l-2.991-2.995 7.731-7.743 2.991 2.995L7.31 14.79zm-3.682-1.551l2.238 2.241-3.116.879.878-3.12zM18.372 2.804L16.292.722c-.405-.406-1.871-1.174-3.042 0L2.716 11.263a.725.725 0 00-.192.329L.937 17.245a.768.768 0 00.192.738c.192.196.576.23.738.192l5.65-1.591a.725.725 0 00.328-.192L18.372 5.85a2.16 2.16 0 000-3.047z"}})])
          )
        }
      }
    